module.exports = __webpack_public_path__ + "static/img/0403_02.14b331f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0403_02.png
// module id = nv7g
// module chunks = 1